import { render } from "./Proposal.vue?vue&type=template&id=2b3b4ec9&scoped=true"
import script from "./Proposal.vue?vue&type=script&lang=js"
export * from "./Proposal.vue?vue&type=script&lang=js"

import "./Proposal.vue?vue&type=style&index=0&id=2b3b4ec9&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3b4ec9"]])

export default __exports__